import { CLEAR_ALL, LOGOUT } from '../../../store/Types';

export const ALL_RONDAS = 'ALL_RONDAS';
export const ACTIVO_RONDAS = 'ACTIVO_RONDAS';
export const LOADING_ALL_RONDAS = 'LOADING_ALL_RONDAS';
export const PARAMS_RONDAS = 'PARAMS_RONDAS';

const initialState = {
  all: [],
  activo: null,
  loadingAll: false,
  params: {
    torneo: null,
  },
};

export const rondasReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_RONDAS:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case ACTIVO_RONDAS:
      return {
        ...state,
        activo: action.payload,
      };
    case LOADING_ALL_RONDAS:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case PARAMS_RONDAS:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
